import {DropdownOption} from '../../../model/controls/DropdownOption';
import {ComparisonType} from '../../../model/search/advanced/ComparisonType';
import {Operator, SearchExpression} from '../../../model/search/advanced/SearchExpression';
import {Field} from '../../../model/search/advanced/Field';
import {DateRangeField} from '../../../model/search/advanced/DateRangeField';
import {NumberRangeField} from '../../../model/search/advanced/NumberRangeField';
import {MultiFullTextField} from '../../../model/search/advanced/MultiFullTextField';
import {MultiTextField} from '../../../model/search/advanced/MultiTextField';
import {MultiTagField} from '../../../model/search/advanced/MultiTagField';
import {MultiNamedEntityField} from '../../../model/search/advanced/MultiNamedEntityField';
import {MultiCollectionField} from '../../../model/search/advanced/MultiCollectionField';
import {MultiSearchTermField} from '../../../model/search/advanced/MultiSearchTermField';
import {SingleFullTextField} from '../../../model/search/advanced/SingleFullTextField';
import {SingleTextField} from '../../../model/search/advanced/SingleTextField';
import {SingleBooleanField} from '../../../model/search/advanced/SingleBooleanField';
import {BatesRangeField} from '../../../model/search/advanced/BatesRangeField';
import {AdvancedSearch} from '../../../model/search/advanced/AdvancedSearch';
import {ResourceEntityType, ResourceEntityTypeUtils} from '../../../model/resources/ResourceEntityType';
import {ResourceEntityCategory} from "../../../model/resources/ResourceEntityCategory";
import angular from "angular";
import { Factory } from "../../../services/Factory";


export interface IExpressionGroupScope extends angular.IScope {
  fields: Field[];
  searchExpression: SearchExpression;
  project;
  collection: any;
  savedSearches: AdvancedSearch[];
  removeField: (field: Field) => void;
  removeGroup: (expression: SearchExpression) => void;
  search: Function;
  isInstanceOf: Function;
  DateRangeField;
  NumberRangeField;
  MultiFullTextField;
  MultiTextField;
  MultiTagField;
  MultiNamedEntityField;
  MultiCollectionField;
  SingleFullTextField;
  SingleTextField;
  SingleBooleanField;
  BatesRangeField;
  SearchTermField;
  ComparisonType;
  getSuggestions: Function;
  NonAnalyzedFieldDefaultDropdownOptions: DropdownOption<ComparisonType>[];
  NonAnalyzedFieldLimitedDropdownOptions: DropdownOption<ComparisonType>[];
  AnalyzedFieldDropdownOptions: DropdownOption<ComparisonType>[];
  NonAnalyzedFieldSearchTermDropdownOptions: DropdownOption<ComparisonType>[];
  Operator: typeof Operator;
}

export interface IExpressionGroupAttributes extends angular.IAttributes {
}

export class ExpressionGroup implements angular.IDirective {
  public restrict = "E";
  public templateUrl: string;
  public scope = {
    searchExpression: "=ngModel",
    fields: "=availableFields",
    project: "=",
    collection: "=",
    savedSearches: "="
  };
  public require = ["ngModel"];
  public link: (scope: IExpressionGroupScope, element: angular.IAugmentedJQuery, attrs: IExpressionGroupAttributes) => void;


  constructor(searchService: SearchService, layerService: any, configService: app.services.IConfigService, httpService: app.services.IHttpWrapperService, $rootScope: IRootScope, $compile: angular.ICompileService, $timeout: angular.ITimeoutService) {
    this.templateUrl = "partials/search/advanced/expression_group.html";
    this.link = (scope: IExpressionGroupScope, element: angular.IAugmentedJQuery, attrs: IExpressionGroupAttributes) => {
      let dropAreaContainer = element.find(".drop-area-container");
      let elements: JQuery;

      $compile($('<div data-type="group" style="display: table-row" ng-repeat="searchExpression in searchExpression.searchExpressions"><div style="display: inline-table; width: 100%;"><div style="display: table-row"><div style="display: table-cell; font-size: 24px; vertical-align: middle; padding-right: 5px;"><a ng-click="removeGroup(searchExpression)" class="close"><i class="fas fa-minus-circle"></i></a></div><div style="display: table-cell; width: 100%;"><iio-advanced-search-expression-group ng-model="searchExpression" saved-searches="savedSearches" project="project" collection="collection" available-fields="fields"></iio-advanced-search-expression-group></div></div></div></div>'))(scope).insertAfter(element.find("[data-type='field']"));

      scope.Operator = Operator;

      scope.removeField = field => scope.searchExpression.fields = _.without(scope.searchExpression.fields, field);

      scope.removeGroup = searchExpression => scope.searchExpression.searchExpressions = _.without(scope.searchExpression.searchExpressions, searchExpression);

      scope.search = (project, collection, expression: SearchExpression, page: number, limit: number) => {
        $rootScope.$broadcast("Search.SearchExecuted", {advanced: true, expression});
      };

      scope.getSuggestions = (fieldName: string, viewValue: string) => {
        let url = `${configService.getServerBaseUrl()}/project/${scope.project.id}${scope.collection ? '/collection/' + scope.collection.id : ''}/field/${fieldName}/search/advanced/suggest`;

        return httpService.$http({
          method: "GET",
          url: url,
          params: {
            query: viewValue
          }
        }).then(response => response.data);
      };

      scope.DateRangeField = DateRangeField;
      scope.NumberRangeField = NumberRangeField;
      scope.MultiFullTextField = MultiFullTextField;
      scope.MultiTextField = MultiTextField;
      scope.MultiTagField = MultiTagField;
      scope.MultiNamedEntityField = MultiNamedEntityField;
      scope.MultiCollectionField = MultiCollectionField;
      scope.MultiSearchTermField = MultiSearchTermField;
      scope.SingleFullTextField = SingleFullTextField;
      scope.SingleTextField = SingleTextField;
      scope.SingleBooleanField = SingleBooleanField;
      scope.BatesRangeField = BatesRangeField;
      scope.ComparisonType = ComparisonType;

      scope.NonAnalyzedFieldDefaultDropdownOptions = [
        new DropdownOption("is", ComparisonType.Equals),
        new DropdownOption("is not", ComparisonType.NotEquals),
        new DropdownOption("contains", ComparisonType.Contains),
        new DropdownOption("starts with", ComparisonType.StartsWith),
        new DropdownOption("ends with", ComparisonType.EndsWith)];

      scope.NonAnalyzedFieldDefaultDropdownPluralOptions = [
        new DropdownOption("are", ComparisonType.Equals),
        new DropdownOption("are not", ComparisonType.NotEquals),
        new DropdownOption("contain", ComparisonType.Contains),
        new DropdownOption("start with", ComparisonType.StartsWith),
        new DropdownOption("end with", ComparisonType.EndsWith)];

      scope.NonAnalyzedFieldLimitedDropdownOptions = [
        new DropdownOption("is", ComparisonType.Equals),
        new DropdownOption("is not", ComparisonType.NotEquals)];

      scope.NonAnalyzedFieldRangeDropdownOptions = [
        new DropdownOption("is", ComparisonType.Equals),
        new DropdownOption("between", ComparisonType.Between),
        new DropdownOption("greater than equal", ComparisonType.GreaterThanEquals),
        new DropdownOption("less than equal", ComparisonType.LessThanEquals)];

      scope.AnalyzedFieldDropdownOptions = [
        new DropdownOption("contains phrase", ComparisonType.Equals),
        new DropdownOption("does not contain phrase", ComparisonType.NotEquals),
        new DropdownOption("term prefixed with", ComparisonType.StartsWith)];

      scope.NonAnalyzedFieldSearchTermDropdownOptions = [
        new DropdownOption("hits", ComparisonType.Equals),
        new DropdownOption("does not hit", ComparisonType.NotEquals)];

      scope.ResourceEntityTypeOptions = [];

      ResourceEntityTypeUtils.ResourceEntityTypes.forEach(t => {
        if (t.type !== ResourceEntityCategory.PII || scope.project?.enhancedPiiDetection) {
          scope.ResourceEntityTypeOptions.push(new DropdownOption(t.name, Object.keys(ResourceEntityType).filter(e => ResourceEntityType[e] == t.id)[0].toString()));
        }
      });

      scope.getResourceEntityTypeIndex = (resourceEntityType) => {
        const index = _.findIndex(ResourceEntityTypeUtils.ResourceEntityTypes, e => e.id === resourceEntityType.value);

        return index >= 0 ? index : 0;
      }

      scope.$watch("searchExpression.fields", (newValue, oldValue) => {
        if (newValue instanceof Array && newValue.length > 0 && _.any(newValue, v => v instanceof MultiNamedEntityField || v.instance instanceof MultiNamedEntityField)) {
          scope.resourceEntityTypeChanged = false;

          $timeout(() => scope.resourceEntityTypeChanged = true);
        }
      }, true);

      scope.$watch("searchExpression.operator", value => {
        scope.searchExpression.operator = value ? Operator.Or : Operator.And;
      });

      scope.isInstanceOf = Utilities.isInstanceOf;

      $rootScope.$on("Search.SearchExecuted.Externally", (e, expression) => {
        scope.searchExpression = expression;
        $rootScope.$broadcast("Search.SearchExecuted", {advanced: true, expression});
      });

      if (dropAreaContainer.parents(".drop-area-container").length == 0) {
        elements = dropAreaContainer.add(dropAreaContainer.parents(".panel-body"));
      } else {
        elements = dropAreaContainer;
      }

      elements.on("dragover", (e: JQueryEventObject) => {
        (e.originalEvent as DragEvent).dataTransfer.dropEffect = 'copy';
        $(".target-area").not($(e.target).find(".target-area")).css("display", "none");
        $(e.target).parents(".drop-area-container").first().find(".target-area").first().css("display", "block");
        $(e.target).find(".target-area").first().css("display", "block");
        e.preventDefault();
      }).on("dragover", () => {
        return false;
      });

      elements.on("drop", (e: JQueryEventObject) => {
        e.preventDefault();
        if ((e.originalEvent as DragEvent).dataTransfer.getData("text").indexOf("group") >= 0) {
          scope.searchExpression.searchExpressions.push(new SearchExpression());
        } else if ((e.originalEvent as DragEvent).dataTransfer.getData("text").indexOf("search:") >= 0) {
          let expression = SearchExpression.From((_.where(scope.savedSearches, {id: (e.originalEvent as DragEvent).dataTransfer.getData("text").replace("search:", "")})[0] as any).expression);

          scope.searchExpression.operator = expression.operator;
          expression.fields.forEach(f => scope.searchExpression.fields.push(f));
          expression.searchExpressions.forEach(e => scope.searchExpression.searchExpressions.push(e));
        } else {
          const field = _.find(scope.fields, field => field.name == (e.originalEvent as DragEvent).dataTransfer.getData("text"));

          scope.searchExpression.fields.push(field.clone());
        }

        scope.$apply();
      }).on("drop", () => {
        return false;
      });
    };
  }
}

frontendApp.directive("iioAdvancedSearchExpressionGroup", ["AdvancedSearchService", "LayerService", "ConfigService", "HttpService", "$rootScope", "$compile", "$timeout", Factory.Create(ExpressionGroup)]);
